/**
 * Maps the Auth0 custom domain the login page is being served from to the
 * corresponding Lexara console signup page.
 *
 * The signup link on the login screens must send users to the console's own
 * signup flow (which provisions a firm and a Stripe subscription) rather than
 * to Auth0's built-in signup screen, which does neither.
 *
 * Keyed by hostname so a single build can be deployed to every environment.
 */
const SIGNUP_URL_BY_AUTH_HOST: Record<string, string> = {
  // lexara-dev tenant
  "dev.auth.lexara.app": "https://dev.console.lexara.app/signup",
  // dev-jzptyw28tzvm4o6l tenant — backs the *test* console, not dev
  "auth.lexara.app": "https://test.console.lexara.app/signup",
  // lexara-prod tenant
  "auth.console.lexara.app": "https://console.lexara.app/signup",
};

/** Production console, used for the lexara-prod tenant and as a safe fallback. */
export const DEFAULT_CONSOLE_SIGNUP_URL = "https://console.lexara.app/signup";

/**
 * Resolves the console signup URL for the host the page is served from.
 * Unrecognized hosts fall back to the production console so the link is never
 * dead, and never points at Auth0's default signup screen.
 */
export function getConsoleSignupUrl(
  hostname: string = typeof window !== "undefined"
    ? window.location.hostname
    : ""
): string {
  return SIGNUP_URL_BY_AUTH_HOST[hostname] ?? DEFAULT_CONSOLE_SIGNUP_URL;
}
